<template>

    <div id="main">

        <div id="setup_container" class="br-2">

            <div class="w-full flex flex-row justify-between py-4 bg-gray-200">
                <div class="f1-step active flex flex-col items-center content-center justify-center w-full">
                    <div class="f1-step-icon text-center"><i class="fa fa-file"></i></div>
                    <span>Terms</span>
                </div>
                <!-- <div class="f1-step flex flex-col items-center content-center justify-center w-full" v-bind:class="{ active: current >= 1 }">   
                    <div class="f1-step-icon text-center"><i class="fa fa-key"></i></div>
                    <span>Account</span>
                </div>
                <div class="f1-step flex flex-col items-center content-center justify-center w-full" v-bind:class="{ active: current >= 1 }">   
                    <div class="f1-step-icon text-center"><i class="fa fa-user"></i></div>
                    <span>About</span>
                </div>
                <div class="f1-step flex flex-col items-center content-center justify-center w-full" v-bind:class="{ active: current >= 1 }">   
                    <div class="f1-step-icon text-center"><i class="fas fa-share-alt-square"></i></div>
                    <span>Social</span>
                </div> -->
                <div class="f1-step flex flex-col items-center content-center justify-center w-full" v-bind:class="{ active: current >= 1 }">   
                    <div class="f1-step-icon text-center"><i class="fa fa-check"></i></div>
                    <span>Complete</span>
                </div>
            </div>

            <div id="setup" class="br-2 pt-3">

                <router-view></router-view>

            </div>

        </div>

        <div class="clear"></div>

    </div>

</template>

<script>

    import { EventBus } from '../../utils/events'

	export default {
        name: 'Login',
		data () {
			return {
                msg: 'Welcome to Your Vue.js App',
                current: 0,
                percent: 12.5
			}
        },
        mounted() {
            this.$nextTick(function () {
                EventBus.$on('account-setup-navigation', this.navigate);
            }.bind(this));

            if(this.$route.name == "FinalizeAccount") {
                this.current = 1;
                this.updateProgress();
            } else if (this.$route.name == "FinalizeAbout") {
                this.current = 2;
                this.updateProgress();
            } else if (this.$route.name == "FinalizeSocial") {
                this.current = 3;
                this.updateProgress();
            } else if (this.$route.name == "FinalizeComplete") {
                this.current = 4;
                this.updateProgress();
            }
        },
        destroyed() {
            EventBus.$off('account-setup-navigation', this.navigate);
        },
        methods: {
            navigate(data) {

                if(data.direction == "forward") {
                    if(data.at == "terms") {
                        this.$router.push({ name: 'FinalizeAccount'})
                        this.current = 1;
                    }
                    
                    if(data.at == "account") {
                        this.$router.push({ name: 'FinalizeAbout'})
                        this.current = 2;
                    }

                    if(data.at == "about") {
                        this.$router.push({ name: 'FinalizeSocial'})
                        this.current = 3;
                    }

                    if(data.at == "social") {
                        this.$router.push({ name: 'FinalizeComplete'})
                        this.current = 4;
                    }

                }

                if(data.direction == "backward") {
                    if(data.at == "account") {
                        this.$router.push({ name: 'FinalizeTerms'})
                        this.current = 0;
                    }

                    if(data.at == "about") {
                        this.$router.push({ name: 'FinalizeAccount'})
                        this.current = 1;
                    }
                    
                    if(data.at == "social") {
                        this.$router.push({ name: 'FinalizeAbout'})
                        this.current = 2;
                    }

                    if(data.at == "complete") {
                        this.$router.push({ name: 'FinalizeSocial'})
                        this.current = 3;
                    }

                }

                this.updateProgress();
                
            },

            updateProgress() {

                this.percent = 10 + ((this.current / 5) * 100);

            }
        }
    }

</script>

<style>

    .VideoBg {
        min-height: 640px;
        /* overflow:scroll !important; */
    }

    .VideoBg__content {
        text-align: center;
        background-color: rgba(52, 72, 92, 0.7);
        overflow-y: scroll;
    }

</style>

<style scoped>



    #main {
        position:absolute;
        top:0;
        width: 100%;
        min-height: 100%;

        display: flex;
        align-items: center;
        justify-content: center;

        box-sizing: border-box
    }

    .h-100 {
        height: 100vh !important;
    }

    #setup_container {
        background-color: #fff;
        height: auto;
        width: 800px;
        /* position: relative; */
        box-sizing: border-box
    }

    #setup_container a:hover {
        text-decoration: none;
    }

    #setup_container h1 {
        font-size: 36px;
        font-weight: 600;
    }

    .steps-container {
        padding-top: 30px;
        padding-bottom: 30px;
        background-color: #F6F7F8;
    }

    /* .f1-steps { overflow: hidden; position: relative; }
 
    .f1-progress { position: absolute; top: 25px; left: 0; width: 100%; height: 1px; background: #ddd; }
    .f1-progress-line { position: absolute; top: 0; left: 0; height: 1px; background: #004F96; }

    .f1-step { position: relative; float: left; width: 20%; padding: 0 5px; } */

    .f1-step-icon {
        display: inline-block; width: 40px; height: 40px; margin-top: 4px; background: #ddd;
        font-size: 16px; color: #fff; line-height: 40px;
        -moz-border-radius: 50%; -webkit-border-radius: 50%; border-radius: 50%;
    }
    .f1-step.activated .f1-step-icon {
        background: #fff; border: 1px solid #f35b3f; color: #f35b3f; line-height: 38px;
    }
    .f1-step.active .f1-step-icon {
        background: #004F96;
    }

    .f1-step p { color: #ccc; }
    .f1-step.activated p { color: #f35b3f; }
    .f1-step.active p { color: #004F96; }

    .f1-step p {
        margin-bottom: 0px !important;
    }


    #buttons {
        position: absolute;
        bottom: 0px;
        /* height: 60px; */
        width: 100%;
        /* background-color: #000; */
        padding-bottom: 25px;
        text-align: right;
        padding-right: 30px;
    }

    @media only screen and (max-width: 800px) { 
        #setup_container { 
            min-width: 100%;
            width: 100% ;
        }
    }

.clear {
  border: 0;
  clear: both;
  height: 0;
}



</style>
